var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 46V58L18 64H30L36 58V46L40.9584 41.0416C45.467 36.533 48 30.4057 48 24.0294C48 10.7746 37.2548 0 24 0C10.7452 0 0 10.7746 0 24.0294C0 30.4057 2.53295 36.533 7.04163 41.0416L12 46ZM30 55.5147V48H18V55.5147L20.4853 58H27.5147L30 55.5147ZM31.5147 42H27V24H21V42H16.4853L11.2843 36.799C7.9031 33.4178 6 28.8176 6 24.0294C6 14.0787 14.0684 6 24 6C33.9316 6 42 14.0787 42 24.0294C42 28.8176 40.0969 33.4178 36.7157 36.799L31.5147 42Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.dda5a11af29506588e3a5b02679be330.svg";
export { ForwardRef as ReactComponent };